import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';
import {
  CheckAccessToPackageResponse,
  DownloadResponse,
  GetDownloadTypeStatusesResponse,
  PackagesEndpointMethodDownloadKit,
  GetPackageCompanyRingVersionsResponse,
} from '../types/types';

export class DownloadKitButtonSelectorGzDataProvider extends BaseWebComponentDataProvider {
  private dataProviderType = DataProviderType.CORE;
  private endpoint = 'Packages';

  public async getDownloadTypeStatuses(
    kitsIds: Array<number>,
    oemKitId: number
  ): Promise<GetDownloadTypeStatusesResponse> {
    return await ConsoleRequest.createRequest<GetDownloadTypeStatusesResponse>({
      dataProviderType: this.dataProviderType,
      payload: {
        downloadTypes: kitsIds,
        oemKitId: oemKitId,
      },
      endpoint: this.endpoint,
      method: PackagesEndpointMethodDownloadKit.GET_DOWNLOAD_TYPE_STATUSES,
    });
  }

  /**
   * Create url to download, and start download the image if is not on the disc and return the status
   * @param packageId
   * @param downloadType
   */
  public async download(packageId: string, downloadType: number): Promise<DownloadResponse> {
    return await ConsoleRequest.createRequest<DownloadResponse>({
      dataProviderType: this.dataProviderType,
      payload: {
        packageId: packageId,
        downloadType: downloadType,
      },
      endpoint: this.endpoint,
      method: PackagesEndpointMethodDownloadKit.DOWNLOAD,
    });
  }

  /**
   * start download the image if is not on the disc and return the status
   * @param packageId
   * @param downloadType
   */
  public async checkAccessToPackage(packageId: string, downloadType: number): Promise<CheckAccessToPackageResponse> {
    return await ConsoleRequest.createRequest<CheckAccessToPackageResponse>({
      dataProviderType: this.dataProviderType,
      payload: {
        packageId: packageId,
        downloadType: downloadType,
      },
      endpoint: this.endpoint,
      method: PackagesEndpointMethodDownloadKit.CHECK_ACCESS_TO_PACKAGE,
    });
  }

  public async getPackageCompanyRingVersions(packageCompanyId: string): Promise<GetPackageCompanyRingVersionsResponse> {
    return await ConsoleRequest.createRequest<GetPackageCompanyRingVersionsResponse>({
      dataProviderType: this.dataProviderType,
      payload: {
        packageCompanyId: packageCompanyId,
      },
      endpoint: this.endpoint,
      method: PackagesEndpointMethodDownloadKit.GET_SELECTED_PACKAGE_COMPANY_RING_DETAILS,
    });
  }
}
